import React, { useState, useEffect } from "react";

import {
  Paper,
  TableRow,
  TableBody,
  TableContainer,
  TableCell,
  Table,
} from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import {
  DatatablesFooterServerSide,
  TableHeader,
  Title,
  TableCellDefault,
  Loading,
  TableAction,
  ModalDeleteConfirm,
  MasterButton,
} from "App/Component/ui";

import { STYLE_DEFAULT_MASTER } from "App/constants/theme";

import { useDatatablesServerSide, useDatatables } from "App/hooks";
import {
  getByFilterAdjusment,
  headCells,
  RESET_STATE_FORM_FILTER,
  deleteAdjusmentById,
} from "./helpers";

import {
  defaultDateInputDisplay,
  defaultToastError,
  defaultToastSuccess,
} from "App/utils/helpers";

import FormFilterDaftarAdjusmentStock from "./FormFilterDaftarAdjusment";
import { WMS_LGS_INPUT_ADJUST } from "App/constants";

export default function DaftarAdjusmentStock({
  changeTitle,
  changeParentData,
  handleClickMenu,
  changeMenu,
}) {
  const classes = STYLE_DEFAULT_MASTER();
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  const [rows, setRows] = useState([]);
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);

  const [adjusmentID, setAdjusmentID] = useState(null);

  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit
  ) => {
    setLoading(true);

    const res = await getByFilterAdjusment(formFilter, pages, limit);
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });

  function clickUpdate(row) {
    changeParentData({
      id: row?.id,
      date: defaultDateInputDisplay(row.date, true),
      gudang: row.namaGudang,
      gudang_id: row.gudang_id,
      status: row.status,
    });

    changeMenu(WMS_LGS_INPUT_ADJUST);
    changeTitle(WMS_LGS_INPUT_ADJUST);
    handleClickMenu({
      code: WMS_LGS_INPUT_ADJUST,
      name: "Input Adjusment Stock",
    });
  }

  function clickDelete(row) {
    setAdjusmentID(row.id);
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  }

  async function deleteList() {
    const res = await deleteAdjusmentById(adjusmentID);

    if (res.state) {
      defaultToastSuccess(res.message);
      setNewData();
    } else {
      defaultToastError(res.message);
    }

    setShowModalDeleteConfirm(false);
  }

  return (
    <>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}
      <div className={classes.root}>
        <Title title={"Daftar Adjusment Logistik"} />

        <Paper
          className={classes.paper}
          style={{
            padding: "1rem",
          }}>
          <FormFilterDaftarAdjusmentStock
            formFilter={formFilter}
            setFormFilter={setFormFilter}
            setNewData={setNewData}
          />
          <Loading show={loading} />
          <div className='mt-1'>
            <TableDaftarAdjustmentStock
              rows={rows}
              classes={classes}
              clickDelete={clickDelete}
              clickUpdate={clickUpdate}
            />
            <DatatablesFooterServerSide
              totalData={totalData}
              pagination={pagination}
              handleChangeLimit={handleChangeLimit}
              onPrevious={onPrevious}
              onNext={onNext}
              currentPage={pagination.page}
              handleClickPageNumber={handleClickPageNumber}
            />
          </div>
        </Paper>
      </div>
    </>
  );
}

const TableDaftarAdjustmentStock = ({
  rows,
  classes,
  clickDelete,
  clickUpdate,
}) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id", "namaGudang"],
  });

  return (
    <>
      <TableContainer className='custom-scrollbar'>
        <Table
          className={classes.table}
          aria-labelledby='tableTitle'
          size={"medium"}
          aria-label='enhanced table'>
          <TableHeader
            classes={classes}
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={length}
            headCells={headCells}
          />
          <TableBody>
            {stableSort(rows, getComparator(order, orderBy)).map(
              (row, index) => {
                return (
                  <TableRow
                    hover
                    tabIndex={-1}
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                    }}>
                    <TableCell
                      component='th'
                      scope='row'
                      padding='none'
                      align='center'>
                      {index + 1}
                    </TableCell>
                    <TableCell
                      component='th'
                      scope='row'
                      padding='none'
                      align='center'>
                      <TableAction
                        clickDelete={() => clickDelete(row)}
                        isDelete={row.status ? false : true}
                        clickUpdate={() => clickUpdate(row)}
                      />
                    </TableCell>
                    <TableCell align='left'>{row?.id}</TableCell>
                    <TableCell align='left'>{row?.namaGudang}</TableCell>
                    <TableCell align='left'>
                      {" "}
                      {row.status ? (
                        <MasterButton
                          style={{ borderRadius: 20 }}
                          name={"PROCESS"}
                          color={"warning"}
                          disabled
                        />
                      ) : (
                        <MasterButton
                          style={{ borderRadius: 20 }}
                          name={"DRAFT"}
                          color={"green"}
                          disabled
                        />
                      )}
                    </TableCell>

                    <TableCellDefault row={row} type='custom' />
                  </TableRow>
                );
              }
            )}
            {rows.length === 0 && (
              <TableRow>
                <TableCell align='center' colSpan={headCells.length}>
                  Tidak ada data
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
